import { useMutation } from "@tanstack/react-query";
import { AuthService } from "../services/auth.service";
import { LoginRequestDto } from "../dto/auth.dto";

export const useLoginHook = () => {
  return useMutation({
    mutationFn: (data: LoginRequestDto) => AuthService.login(data),
  });
};
